import { useEffect, useState } from "react";
import UsersMFAAPI from "../api/UsersMFAAPI";

const useUsersMfa = () => {
	const [users, setUsers] = useState([]);
	const [globallyEnabled, setGloballyEnabled] = useState(true);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		let cancelled = false;

		(async () => {
			setLoading(true);
			setError(null);

			try {
				const result = await UsersMFAAPI.getUsers();
				if (!cancelled) {
					setUsers(result?.users || []);
					setGloballyEnabled(result?.mfa_globally_enabled !== false);
				}
			} catch (err) {
				if (!cancelled) setError(err.message);
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();

		return () => {
			cancelled = true;
		};
	}, []);

	return { users, setUsers, globallyEnabled, loading, error };
};

export default useUsersMfa;
